import { useContext } from "react";
import { OrderSplitAPIResponse, PaymentMethods } from "../../../../interfaces/interfaces";
import { Context, IContext } from "../../../../context/ContextApp";
import { getPaymentDetails, IDetail } from "../../../../utils/OrderPaymentDetails";
import Button, { ButtonType } from "../../../../components/Button/Button";
import LoadingSpinner from "../../../../components/LoadingSpinner/LoadingSpinner";
import Counter from "../Counter/Counter";
import { subdomainTypes } from "../../../../context/availableSubdomains";

interface Props {
  splitAPIResponse: OrderSplitAPIResponse;
  APILoading: boolean;
  timerId: ReturnType<typeof setInterval> | null;
  counter: number;
  onRecheckStock: () => void;
  onSubmitOrder: () => void;
}

const PaymentDetailsBlock = ({
  splitAPIResponse,
  APILoading,
  timerId,
  counter,
  onRecheckStock,
  onSubmitOrder,
}: Props) => {
  const { appBranch }: IContext = useContext(Context);
  const paymentDetails = getPaymentDetails(splitAPIResponse.current_order, appBranch);
  const isOnlinePayment = splitAPIResponse.current_order.payment_method === PaymentMethods.Online;

  return (
    <div className="payment-details-block">
      <div className="payment-details-content">
        <h3>Payment Details</h3>

        <div className="payment-summary">
          <div className="payment-breakdown">
            {paymentDetails.map((paymentDetail: IDetail) => (
              <div key={`paymentDetail_${paymentDetail.title}`} className="payment-row">
                <span className={paymentDetail.boldTitle ? "bold" : ""}>
                  {paymentDetail.title}:
                </span>
                <span>{paymentDetail.value}</span>
              </div>
            ))}
          </div>
        </div>

        {isOnlinePayment && appBranch === subdomainTypes.NZ && (
          <div className="payment-info">
            <strong>NOTE:</strong> Merchant Service Fee will be calculated and added on the
            following page, prior to payment confirmation.
          </div>
        )}

        <div className="timer-section">
          <Counter counter={counter} />
        </div>

        <div className="action-buttons">
          {!APILoading && timerId ? (
            <Button type={ButtonType.primary} onClick={onSubmitOrder} className="submit-button">
              Submit Order
            </Button>
          ) : APILoading ? (
            <LoadingSpinner inline />
          ) : (
            <Button type={ButtonType.primary} onClick={onRecheckStock} className="recheck-button">
              Recheck Stock
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default PaymentDetailsBlock;
